import CartSubtotal from './cart-subtotal';

export default CartSubtotal;
